export default __webpack_public_path__ + "static/media/play-button.0d16c685.png";